import Matches from 'matches/components/Matches';

const routes = {
  path: 'matches',
  element: <Matches />
};

export default routes;
